export const steps = [
  {
    img: "/step2.webp",
    step: 2,
    text: "Give your collection a name, ticker Symbol, description and cost per NFT",
  },
  {
    img: "/step3.webp",
    step: 3,
    text: "Create one or multiple classes and specify The amount of NFTs for each. Drag and drop your attribute folders containing the corresponding trait files for each class.",
  },
  {
    img: "/step4.webp",
    step: 4,
    text: "Configure allow list. Set max mint amount per wallet and cost per NFT",
  },
  {
    img: "/step5.webp",
    step: 5,
    text: "Generate preview images of your collection per class",
  },
  {
    img: "/step6.webp",
    step: 6,
    text: "Review and deploy your collection’s smart contract",
  },
  {
    img: "/step7.webp",
    step: 7,
    text: "Configure your collection in your profile. Pre-mint NFTs. Enable allow listed minting.",
  },
  {
    img: "/step8.webp",
    step: 8,
    text: "Customize your mint page. Upload a background image behind a mint button.Customize your mint page. Upload a background image behind a mint button.",
  },
];
